import type { Country, Resort } from '@/shared/model';
import type { ApiCountryResort } from './types';

function toNullableNumber(raw: number | null | undefined): number | null {
  return typeof raw === 'number' && Number.isFinite(raw) ? raw : null;
}

export function adaptCountryResorts(data: ApiCountryResort[], country: Pick<Country, 'id' | 'name'>): Resort[] {
  return data.map((api) => ({
    id: api.id,
    name: api.name,
    countryId: country.id,
    countryName: country.name,
    isPopular: !!api.isPopular,
    minPrice: toNullableNumber(api.minPrice),
    atFiltering: !!api.atFiltering,
  }));
}
